import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Validates an email address format
 * @param email - The email address to validate
 * @returns Object with isValid boolean and optional error message
 */
export function validateEmail(email: string): { isValid: boolean; error?: string } {
  // Empty email is valid (optional)
  if (!email || !email.trim()) {
    return { isValid: true };
  }

  const trimmedEmail = email.trim();
  
  // Basic email regex pattern
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!emailRegex.test(trimmedEmail)) {
    return { 
      isValid: false, 
      error: "Invalid email format" 
    };
  }

  // Check for common invalid patterns
  if (trimmedEmail.startsWith(".") || trimmedEmail.endsWith(".")) {
    return { 
      isValid: false, 
      error: "Email cannot start or end with a dot" 
    };
  }

  if (trimmedEmail.includes("..")) {
    return { 
      isValid: false, 
      error: "Email cannot contain consecutive dots" 
    };
  }

  return { isValid: true };
}
